import React, { useEffect, useState } from 'react';
import { fetchWorkflow } from '../assets/api.js';
import KnowledgeBase, { DataRoom } from '../assets/KbDataRoom.jsx';
import '../assets/assetWorkflow.css';

function readFilter() {
  const q = (window.location.hash.split('?')[1] || '');
  const params = new URLSearchParams(q);
  return { docId: params.get('doc') || '', docType: params.get('docType') || '' };
}

/** Deal sub-view. Reuses the existing Data Room and Knowledge Base. Not a top-nav item. */
export default function DataRoomPanel({ dealId, onNavigate }) {
  const [wf, setWf] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [filter, setFilter] = useState(readFilter);
  const [tab, setTab] = useState('inventory');

  useEffect(() => {
    let cancel = false;
    setLoaded(false);
    fetchWorkflow(dealId)
      .then((workflow) => {
        if (!cancel) setWf(workflow);
      })
      .catch(() => {
        if (!cancel) setWf(null);
      })
      .finally(() => {
        if (!cancel) setLoaded(true);
      });
    return () => {
      cancel = true;
    };
  }, [dealId]);

  useEffect(() => {
    const onHash = () => setFilter(readFilter());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const inventory = wf || { documents: [], provenance: [], issues: [], facts: [], wells: [] };

  return (
    <div className="mp" data-testid="dataroom-view">
      <div className="mp-head">
        <div>
          <span className="mp-eyebrow">Evidence baseline</span>
          <h2 className="mp-h2">Data room</h2>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" className={`mp-btn small ${tab === 'inventory' ? 'amber' : ''}`} onClick={() => setTab('inventory')}>
            Inventory
          </button>
          <button type="button" className={`mp-btn small ${tab === 'kb' ? 'amber' : ''}`} onClick={() => setTab('kb')}>
            Knowledge base
          </button>
        </div>
      </div>
      <p className="mp-note">
        Indexed from file titles and folder paths. Document contents stay in the private data room.
      </p>
      {!loaded ? <p className="mp-note">Loading the inventory…</p> : null}
      {loaded && tab === 'inventory' ? (
        <div className="aw-root">
          <DataRoom
            wf={inventory}
            focusDocId={filter.docId}
            docType={filter.docType}
            onClearFilter={onNavigate ? () => onNavigate('dataroom') : undefined}
          />
        </div>
      ) : null}
      {loaded && tab === 'kb' ? (
        <div className="aw-root">
          <KnowledgeBase wf={inventory} reviews={{}} onFocus={() => {}} />
        </div>
      ) : null}
    </div>
  );
}
